import React, { useState, useEffect, useReducer, useRef } from "react"
import { connect } from "react-redux"
import {
  Table,
  Input,
  Button,
  Row,
  Col,
  Form,
  Card,
  Space,
  Tag,
  Avatar,
  Typography,
  Divider,
  Alert,
  Switch,
  Badge,
} from "antd"
import {
  SendOutlined,
  ReloadOutlined,
  ArrowLeftOutlined,
  LockOutlined,
  UnlockOutlined,
  BellOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons"
import { columns } from "./columns"
import {
  addSupportFile,
  closedSupport,
  deleteSupportFile,
  getListSupportMessage,
  getSupportFiles,
  resetSupportFlag,
  upsertSupportMessage,
} from "store/actions"
import { withTranslation } from "react-i18next"
import { getCurrentUser, serializeQuery } from "helpers/service_helper"
import { useParams } from "react-router-dom"
import { Link } from "react-router-dom/cjs/react-router-dom.min"
import { SupportFiles } from "../SupportFiles"

const { TextArea } = Input
const { Text, Title } = Typography

const MessageList = props => {
  const {
    lstSupportMessage,
    loading,
    onGetListSupportMessage,
    onUpsertSupportMessage,
    onResetSupportFlag,
    openNotification,
    reload,
    onClosedSupport,
  } = props
  const supportId = useParams().id
  const [errorMessage, setErrorMessage] = useState(null)
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      supportId,
    }
  )
  const [form] = Form.useForm()

  const [countChangeFormInput, setCountChangeFormInput] = useState(0)
  const [autoRefresh, setAutoRefresh] = useState(true)
  const autoRefreshRef = useRef(null)

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    setFormInput({ [name]: newValue })
    setCountChangeFormInput(prev => prev + 1)
  }
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra)
  }

  useEffect(async () => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
    onResetSupportFlag()
  }, [errorMessage, props.success, props.error])

  useEffect(async () => {
    await handleSearchSupportMessages()

    // Set up auto-refresh for Messages
    if (autoRefresh) {
      autoRefreshRef.current = setInterval(async () => {
        await handleSearchSupportMessages()
      }, 30000) // Refresh every 30 seconds
    }

    return () => {
      if (autoRefreshRef.current) {
        clearInterval(autoRefreshRef.current)
      }
    }
  }, [autoRefresh])

  // Cleanup interval on component unmount
  useEffect(() => {
    return () => {
      if (autoRefreshRef.current) {
        clearInterval(autoRefreshRef.current)
      }
    }
  }, [])
  // Fetch data or set initial values if needed
  useEffect(async () => {
    if (reload) {
      await handleSearchSupportMessages()
    }
    if (countChangeFormInput) {
      await handleSearchSupportMessages()
    }
  }, [reload, countChangeFormInput])
  // Function to handle form submission
  const handleSubmit = values => {
    let searchQuery = {
      ...formInput,
    }
    const params = serializeQuery(searchQuery)

    let updatedData = values
    updatedData.supportId = supportId
    onUpsertSupportMessage({ updatedData, params })
    form.resetFields()

    // Immediately refresh to show new message
    setTimeout(async () => {
      await handleSearchSupportMessages()
    }, 1000)
  }
  const handleSearchSupportMessages = async val => {
    let searchQuery = {
      ...formInput,
    }

    const params = serializeQuery(searchQuery)
    onGetListSupportMessage(params)
  }
  // Function to handle edit button click
  const handleEdit = record => {
    // form.setFieldsValue(record)
    // // setSolarBirthDate(record.solarBirthDate)
    // setEditingId(record.id)
  }

  return (
    <>
      {/* Header Section */}
      <Card size="small" style={{ marginBottom: 16 }}>
        <Row gutter={[16, 8]} align="middle">
          <Col>
            <Link to="/support">
              <Button icon={<ArrowLeftOutlined />} type="text">
                بازگشت به لیست
              </Button>
            </Link>
          </Col>

          <Col flex="auto">
            <Space direction="vertical" size={4} style={{ width: "100%" }}>
              {lstSupportMessage && (
                <>
                  <Row gutter={[16, 4]}>
                    <Col>
                      <Text type="secondary">شماره پرونده: </Text>
                      <Text strong>
                        {lstSupportMessage[0]?.support.fileNumbers &&
                        lstSupportMessage[0]?.support.fileNumbers.length > 0
                          ? lstSupportMessage[0]?.support.fileNumbers.join(", ")
                          : lstSupportMessage[0]?.support.fileNumber}
                      </Text>
                    </Col>
                    {!(
                      getCurrentUser().role === "Engineer" ||
                      getCurrentUser().role == "Executor"
                    ) && (
                      <>
                        <Col>
                          <Text type="secondary">شماره تیکت: </Text>
                          <Text strong>
                            {lstSupportMessage[0]?.support.ticketNumber &&
                              lstSupportMessage[0]?.support.ticketNumber}
                          </Text>
                        </Col>
                        <Col>
                          <Text type="secondary">ارسال به: </Text>
                          <Text>{lstSupportMessage[0]?.toName}</Text>
                        </Col>
                        <Col>
                          <Tag
                            color={
                              lstSupportMessage[0]?.support.closed ? "red" : "green"
                            }
                          >
                            {lstSupportMessage[0]?.support.closed
                              ? "بسته شده"
                              : "باز است"}
                          </Tag>
                        </Col>
                      </>
                    )}
                  </Row>
                </>
              )}
            </Space>
          </Col>

          <Col>
            <Space>
              <Space align="center">
                <ClockCircleOutlined />
                <Text type="secondary">به‌روزرسانی خودکار:</Text>
                <Switch
                  size="small"
                  checked={autoRefresh}
                  onChange={setAutoRefresh}
                />
              </Space>

              <Button
                icon={<ReloadOutlined />}
                onClick={() => setCountChangeFormInput(prev => prev + 1)}
              >
                به روز رسانی
              </Button>

              {!(
                getCurrentUser().role === "Engineer" ||
                getCurrentUser().role == "Executor"
              ) && (
                <Button
                  type={lstSupportMessage[0]?.support.closed ? "default" : "primary"}
                  danger={!lstSupportMessage[0]?.support.closed}
                  icon={
                    lstSupportMessage[0]?.support.closed ? (
                      <UnlockOutlined />
                    ) : (
                      <LockOutlined />
                    )
                  }
                  onClick={async () => await onClosedSupport({ id: supportId })}
                >
                  {lstSupportMessage[0]?.support.closed ? "باز کردن" : "بستن"}
                </Button>
              )}

              {lstSupportMessage[0]?.support && (
                <SupportFiles
                  rowData={lstSupportMessage[0]?.support}
                  mainProps={props}
                  setErrorMessage={setErrorMessage}
                />
              )}
            </Space>
          </Col>
        </Row>
      </Card>

      {/* New Message Form */}
      <Card size="small" style={{ marginBottom: 16 }}>
        <Form form={form} onFinish={handleSubmit}>
          <Row gutter={[16, 8]}>
            <Col xs={24}>
              <Form.Item
                name="message"
                rules={[{ required: true, message: "نباید خالی باشد" }]}
                style={{ margin: 0 }}
              >
                <TextArea
                  rows={3}
                  placeholder="پیام خود را در اینجا بنویسید..."
                  style={{ resize: "none" }}
                />
              </Form.Item>
            </Col>
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SendOutlined />}
              >
                ارسال پیام
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>

      {/* Conversation Messages - Messenger Style */}
      <Card
        size="small"
        title={
          <Space>
            <span>پیام‌های تیکت</span>
            {lstSupportMessage &&
              lstSupportMessage[0]?.support &&
              !lstSupportMessage[0]?.support.isRead && (
                <Badge count={1} style={{ backgroundColor: "#ff4d4f" }} />
              )}
          </Space>
        }
        style={{ marginBottom: 16 }}
      >
        <div
          style={{
            maxHeight: 600,
            overflowY: "auto",
            padding: "16px",
            backgroundColor: "#f5f5f5",
          }}
        >
          {lstSupportMessage && lstSupportMessage.length > 0 ? (
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
              {lstSupportMessage.map((item, index) => {
                // Check if message is from current user
                const isMyMessage = item.userId === getCurrentUser().sid

                return (
                  <div
                    key={item.id}
                    style={{
                      display: "flex",
                      justifyContent: isMyMessage ? "flex-start" : "flex-end",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: "70%",
                        minWidth: "300px",
                      }}
                    >
                      <Card
                        size="small"
                        style={{
                          backgroundColor: isMyMessage ? "#e6f7ff" : "#ffffff",
                          border: `1px solid ${
                            isMyMessage ? "#91d5ff" : "#d9d9d9"
                          }`,
                          borderRadius: "8px",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                        }}
                      >
                        {/* Sender Name and Avatar */}
                        <Row gutter={[8, 8]} align="top">
                          {!isMyMessage && (
                            <Col>
                              <Avatar
                                size="small"
                                style={{
                                  backgroundColor: "#1890ff",
                                  flexShrink: 0,
                                }}
                              >
                                {item.name?.charAt(0)}
                              </Avatar>
                            </Col>
                          )}

                          <Col flex="auto">
                            <Space
                              direction="vertical"
                              size={8}
                              style={{ width: "100%" }}
                            >
                              {/* Header: Name and Status */}
                              <Row justify="space-between" align="middle">
                                <Col>
                                  <Text strong style={{ fontSize: "13px" }}>
                                    {isMyMessage ? "شما" : item.name}
                                  </Text>
                                </Col>
                                <Col>
                                  <Space size={4}>
                                    {/* Received Status */}
                                    <Tag
                                      color={item.isReceive ? "green" : "red"}
                                      style={{ fontSize: "11px", margin: 0 }}
                                    >
                                      {item.isReceive
                                        ? "دریافت شده"
                                        : "دریافت نشده"}
                                    </Tag>

                                    {/* Send Status */}
                                    <Tag
                                      color={item.isSend ? "green" : "orange"}
                                      style={{ fontSize: "11px", margin: 0 }}
                                    >
                                      {item.isSend ? "ارسال شده" : "در صف"}
                                    </Tag>
                                  </Space>
                                </Col>
                              </Row>

                              {/* Message Text */}
                              <div
                                style={{
                                  padding: "8px 0",
                                  wordWrap: "break-word",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                <Text>{item.message}</Text>
                              </div>

                              {/* Footer: Date and Time */}
                              <Row justify="space-between" align="middle">
                                <Col>
                                  <Text
                                    type="secondary"
                                    style={{ fontSize: "11px" }}
                                  >
                                    {item.solarCreated || item.solarCreate}
                                  </Text>
                                </Col>
                              </Row>
                            </Space>
                          </Col>

                          {isMyMessage && (
                            <Col>
                              <Avatar
                                size="small"
                                style={{
                                  backgroundColor: "#52c41a",
                                  flexShrink: 0,
                                }}
                              >
                                {getCurrentUser().name?.charAt(0)}
                              </Avatar>
                            </Col>
                          )}
                        </Row>
                      </Card>
                    </div>
                  </div>
                )
              })}
            </Space>
          ) : (
            <Alert message="هنوز پیامی ارسال نشده است" type="info" showIcon />
          )}
        </div>
      </Card>
    </>
  )
}

const mapStateToProps = ({ Supports }) => ({
  lstSupportMessage: Supports.lstSupportMessage,
  lstSupportFiles: Supports.lstSupportFiles,
  loading: Supports.loading,
  error: Supports.error,
  success: Supports.success,
})

const mapDispatchToProps = dispatch => ({
  onGetListSupportMessage: searchValue => dispatch(getListSupportMessage(searchValue)),
  onUpsertSupportMessage: data => dispatch(upsertSupportMessage(data)),
  onResetSupportFlag: () => dispatch(resetSupportFlag()),
  onClosedSupport: data => dispatch(closedSupport(data)),
  onAddSupportFile: supportId => dispatch(addSupportFile(supportId)),
  onGetSupportFiles: supportId => dispatch(getSupportFiles(supportId)),
  onDeleteSupportFiles: id => dispatch(deleteSupportFile(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MessageList))
